export enum PostMessageTypes {
	OnScan = 'onScan',
	PGLoaded = 'pgLoaded',
	ThemeChange = 'themeChange',
	OpenCheckModal = 'openCheckModal',
	OpenReturnModal = 'openReturnModal',
	ConnectionLost = 'connectionLost',
	LogOut = 'pgLogout',
	OpenHotKeysModal = 'openHotKeysModal',
}
